import { render, staticRenderFns } from "./curso-detalle.vue?vue&type=template&id=0fe82e8c&"
import script from "./curso-detalle.vue?vue&type=script&lang=js&"
export * from "./curso-detalle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports